import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import { theme } from "antd";
var SC_THEME = {
  token: {
    colorPrimary: "#ff8916",
    colorInfo: "#0081f0",
    colorSuccess: "#67c23a",
    colorError: "#ea3d2f",
    colorWarning: "#ff8916",
    wireframe: false,
    colorLink: "#ff8916",
    //alias
    boxShadowSecondary: "0 2px 4px 0 rgba(0, 0, 0, 0.08),0 3px 6px -8px rgba(0, 0, 0, 0.12),0 9px 16px 4px rgba(0, 0, 0, 0.05)"
  }
};
var SC_I18N_THEME = {
  token: {
    colorPrimary: "#ff7600",
    colorInfo: "#4285f4",
    colorSuccess: "#22c55e",
    colorWarning: "#ff7600",
    colorError: "#ea4335",
    colorLink: "#ff7600"
  }
};
var token = SC_THEME.token;
export var spiralAppToken = {
  headerHeight: 56,
  colorBgLayout: "#f6f7fa"
};
export var getProLayoutTheme = function getProLayoutTheme() {
  var antdToken = theme.useToken().token;
  return {
    pageContainer: {
      paddingBlockPageContainerContent: 0,
      paddingInlinePageContainerContent: 0
    },
    header: {
      heightLayoutHeader: spiralAppToken.headerHeight,
      colorBgHeader: antdToken.colorBgBase
    },
    sider: {
      colorTextMenu: antdToken.colorText,
      colorTextMenuSecondary: antdToken.colorTextSecondary,
      colorTextHeading: antdToken.colorTextSecondary,
      colorMenuItemDivider: antdToken.colorBgSpotlight,
      colorMenuBackground: antdToken.colorBgElevated,
      colorTextMenuSelected: antdToken.colorPrimaryText,
      colorTextMenuActive: antdToken.colorPrimaryText,
      colorTextMenuItemHover: antdToken.colorText,
      colorBgMenuItemHover: antdToken.colorFillTertiary,
      colorBgMenuItemSelected: "rgba(240,131,0,0.1)",
      colorBgMenuItemActive: "rgba(240,131,0,0.15)",
      colorBgMenuItemCollapsedElevated: antdToken.colorBgElevated,
      colorBgCollapsedButton: antdToken.colorWhite,
      colorTextCollapsedButton: antdToken.colorFill,
      colorTextCollapsedButtonHover: antdToken.colorTextSecondary
    }
  };
};
export var getPureProLayoutTheme = function getPureProLayoutTheme() {
  var antdToken = theme.useToken().token;
  return {
    colorPrimary: antdToken.colorPrimary,
    bgLayout: spiralAppToken.colorBgLayout,
    pageContainer: {
      paddingBlockPageContainerContent: 0,
      paddingInlinePageContainerContent: 0,
      colorBgPageContainer: spiralAppToken.colorBgLayout
    },
    header: {
      heightLayoutHeader: spiralAppToken.headerHeight
    },
    sider: {
      colorTextMenu: antdToken.colorTextBase,
      colorTextMenuSecondary: antdToken.colorTextSecondary,
      colorMenuBackground: spiralAppToken.colorBgLayout,
      colorTextMenuSelected: antdToken.colorPrimaryText,
      colorTextMenuActive: antdToken.colorTextSecondary
    }
  };
};
export var getDefaultSpiralAppTheme = function getDefaultSpiralAppTheme() {
  var config = theme.useToken();
  return _objectSpread(_objectSpread({}, theme.useToken()), {}, {
    token: _objectSpread(_objectSpread({}, config.token), SC_THEME.token)
  });
};
export var DEFAULT_SPIRAL_APP_THEME = {
  token: _objectSpread({}, token)
};
export var DEFAULT_SPIRAL_APP_THEME_V2 = {
  token: _objectSpread({}, SC_I18N_THEME.token)
};
export var getDefaultSpiralAppThemeV2 = function getDefaultSpiralAppThemeV2() {
  var config = theme.useToken();
  return _objectSpread(_objectSpread({}, theme.useToken()), {}, {
    token: _objectSpread(_objectSpread({}, config.token), DEFAULT_SPIRAL_APP_THEME_V2.token)
  });
};